import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useHistory, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";

import SaveBundle from "../../../components/Forms/SaveBundle";
import RouteLeavingGuard from "../../../routes/middleware/RouteLeavingGuard";

import {
  clearBundleFetched,
  getBundle,
  updateBundle,
} from "../../../store/dashboard/Bundles/actions";
import ScrollbarVertical from "../../../components/Common/ScrollbarVertical";
import ProgressWatcher from "../../../components/Common/ProgressWatcher";
import SEO from "../../../components/Common/SEO";
import { clearVideoFetched, getVideo, updateVideo } from '../../../store/dashboard/VideoLibrary/actions';
import SaveVideo from '../../../components/Forms/SaveVideo';

const PROGRESS_TEXT = "Files are uploading now. Please, don't quit this page";

const Update = ({
  filesError,
  clearVideoFetched,
  getVideo,
  updateVideo,
  videoLibrary,
}) => {
  const { updated, item, loading } = videoLibrary;
  const [isDirty, updateDirty] = useState(false);
  const [ready, updateReadyState] = useState(false);
  const {
    params: { fileId },
  } = useRouteMatch("/video-library/:fileId");
  const history = useHistory();
  const saveVideoCallback = useCallback(
    (model) => {
      model.fileId = fileId;
      updateVideo({ model }, history);
    },
    [item]
  );
  const isBlocked = (updated ? false : isDirty) && !filesError;

  useEffect(() => {
    if (!ready && fileId && !loading) {
      getVideo(fileId);
      updateReadyState(true);
    }
  }, [fileId, ready, loading]);

  useEffect(() => {
    return () => {
      clearVideoFetched();
    };
  }, []);

  return (
    <>
      <SEO title="Edit Video" />
      <RouteLeavingGuard
        contentText="Changed data will not be saved. Are you sure you want to cancel?"
        when={isBlocked}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={() => {
          return isBlocked;
        }}
      />
      <ProgressWatcher loading={loading} contentText={PROGRESS_TEXT} />
      <ScrollbarVertical>
        <Row className="page-content h-100">
          <Container fluid className="h-100">
            <Row>
              <Col xs="12">
                <div className="page-title-box d-flex align-items-center justify-content-between">
                  <h4 className="mb-0 font-size-18 text-uppercase">
                    Edit Video
                  </h4>
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs="12" className="pb-4">
                {item && (
                  <SaveVideo
                    model={item}
                    saveVideoFunc={saveVideoCallback}
                    updateDirtyState={updateDirty}
                    history={history}
                  />
                )}
              </Col>
            </Row>
          </Container>
        </Row>
      </ScrollbarVertical>
    </>
  );
};

const mapStateToProps = ({ Progress, VideoLibrary }) => {
  return { filesError: Progress.error, videoLibrary: VideoLibrary };
};

export default connect(mapStateToProps, {
  clearVideoFetched,
  getVideo,
  updateVideo,
})(Update);
